export enum VersionErrorCodes {
    VersionIsOutdated = 'VersionIsOutdated',
}
